import { useState, useCallback } from 'react';

const useLocalModal = () => {
  const [isOpen, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    openModal,
    closeModal,
    modalProps: { isOpen, onRequestClose: closeModal },
  };
};

export default useLocalModal;
